const { SITE_NAME, BRAND_NAME } = process.env;

export default (city) => {
	return {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"item": {
					"@id": `https://${SITE_NAME}.com/`,
					"name": BRAND_NAME,
					"url": `https://${SITE_NAME}.com/`,
				},
			},
			{
				"@type": "ListItem",
				"position": 2,
				"item": {
					"@id": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/`,
					"name": `${city.state.toUpperCase()}`,
					"url": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/`,
				},
			},
			{
				"@type": "ListItem",
				"position": 3,
				"item": {
					"@id": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/${city.name
						.toLowerCase()
						.replace(/ /g, "-")}/`,
					"name": `${city.name.ucFirst()}`,
					"url": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/${city.name
						.toLowerCase()
						.replace(/ /g, "-")}/`,
				},
			},
		],
	};
};
